import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import router from '@/router';
import { mapState, mapActions } from 'vuex';
export default {
  created: function created() {
    this.organiaztionInfoChange();
  },
  computed: _objectSpread({}, mapState({
    permission_routes: function permission_routes(state) {
      return state.permission.routes.filter(function (item) {
        return !item.hidden;
      });
    }
  })),
  watch: {
    $route: {
      handler: function handler(newVal) {
        if (newVal) {
          newVal.matched.length && this.handleSelect(newVal.matched[0].path);
          this.updateSidebar();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: _objectSpread(_objectSpread({
    get_auth: function get_auth() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$store$d, roles, accessRoutes;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('user/getInfo');

              case 2:
                _yield$_this$$store$d = _context.sent;
                roles = _yield$_this$$store$d.roles;
                _context.next = 6;
                return _this.$store.dispatch('permission/generateRoutes', roles);

              case 6:
                accessRoutes = _context.sent;
                router.addRoutes(accessRoutes);

                _this.$router.push('/');

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    organiaztionInfoChange: function organiaztionInfoChange() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _window$_QIANKUN_PROP;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                (_window$_QIANKUN_PROP = window._QIANKUN_PROPS_) === null || _window$_QIANKUN_PROP === void 0 ? void 0 : _window$_QIANKUN_PROP.onGlobalStateChange(function (state, prev) {
                  var _state$organizationIn, _prev$organizationInf;

                  console.log('------state', state, prev);

                  if (state.organizationInfo) {
                    _this2.$store.commit('user/SET_ORGANIZATION_INFO', state.organizationInfo); // 切换门店时更新 IM的userID


                    _this2.$store.commit('chatUser/SET_USER_ID', state.organizationInfo.organizationCode);
                  }

                  if (state.organizationInfo && ((_state$organizationIn = state.organizationInfo) === null || _state$organizationIn === void 0 ? void 0 : _state$organizationIn.organizationCode) !== ((_prev$organizationInf = prev.organizationInfo) === null || _prev$organizationInf === void 0 ? void 0 : _prev$organizationInf.organizationCode)) {
                    _this2.get_auth();

                    if (router.currentRoute.path === '/onlineStore/home') {
                      _this2.$root.isRouterAlive = false;

                      _this2.$nextTick(function () {
                        _this2.$root.isRouterAlive = true;
                      });
                    }
                  }
                }, true);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, mapActions({
    updateSidebar: 'app/updateSideBar'
  })), {}, {
    handleSelect: function handleSelect(key) {
      var temp = this.permission_routes.filter(function (item) {
        return item.path === key;
      });
      temp.length && this.$store.commit('permission/SET_SIDEBAR_ROUTES', temp[0].children);
    }
  })
};